export const formatCurrency = (amount) => new Intl.NumberFormat('en-KE', { style: 'currency', currency: 'KES' }).format(amount || 0);

export const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
};

export const getApprovalStatusColor = (status) => {
    switch (status) {
        case 'APPROVED': return 'green';
        case 'REJECTED': return 'red';
        case 'PENDING': return 'amber';
        default: return 'gray';
    }
};

export const getReimbursementStatusColor = (status) => {
    switch (status) {
        case 'PAID': return 'green';
        case 'CANCELLED': return 'red';
        case 'PENDING': return 'orange';
        default: return 'gray';
    }
};
